import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import McpToolsText from './tools-text';
import McpToolsFiles from './tools-files';
import McpSummaryLink from './summary-link';
import McpChatText from './chat-text';
import Markdown from '@/components/markdown';
import { useMemo } from 'react';
import McpToolsVideo from './tools-video';
import { SVGPureIcon } from '@/ui';
import { Button } from 'antd';
import McpToolsPlan from './tools-plan';
import chatStoreManager from '@/store/chat/manager';
import McpSummaryOutput from './summary-output';

const REASON_MAP = {
  'RISK_CONTROL': '4', // 风控
}

const McpSummary = observer((props) => {
  const {
    mcpStore,
    event,
    messageItem,
    onRenew,
    isLastMessage,
    type,
    handleSend,
    isAITyping,
  } = props;

  const {
    content,
    description,
    attachments,
    plan,
  } = event;

  const planList = useMemo(() => {
    const list = plan?.plan || [];
    if(JSON.stringify(list) === '{}'){
      return [];
    }else{
      return list
    }
  }, [plan]);

  const fixedAttachments = useMemo(() => {
    const textAttachments = [];
    const fileAttachments = [];
    const htmlAttachments = [];
    const videoAttachments = [];

    if(attachments){
      attachments.forEach(item => {
        if(item.type == "file"){
          fileAttachments.push(item);
        }
        // if(item.contentType == "html"){
        //   // 不再支持附件中的 html
        //   // htmlAttachments.push(item);
        // }
        // else if(item.contentType == "video"){
        //   // videoAttachments.push(item); // 总结中已有伪 video，不再单独显示
        //   fileAttachments.push(item);
        // }
        // else if(item.type == "file"){
        //   fileAttachments.push(item);
        // }
        // else if(item.type == "text"){
        //   textAttachments.push(item);
        // }
      });
    }

    return {
      textAttachments,
      fileAttachments,
      htmlAttachments,
      videoAttachments,
    }
  }, [attachments]);


  if(
    event.type == "agentStatus" 
    && event.success === false
  ){
    if(isLastMessage){
      return (
        <div className={`flex mt-12px h-92px w-full rounded-12px flex-col justify-center pl-16px pr-16px bg-white border-1px border-black border-opacity-10`}>
          <div className="flex h-20px items-center">
            <SVGPureIcon name={`mcp_error`} className='size-16px mr-8px text-[#FF3B30] flex-shrink-0' />
            <div className="font-bold">
              {
                event.reason == REASON_MAP.RISK_CONTROL
                ? '执行过程中，发现敏感信息，任务已自动中断'
                : '资源紧张，任务已中断，您可以重新提交任务'
              }
            </div>
          </div>
          
          <div className="flex justify-end mt-12px">
            <Button
              type='black'
              onClick={
                () => {
                  if(event.reason == REASON_MAP.RISK_CONTROL) return;
                  onRenew?.();
                }
              }
              className='!rounded-full !w-88px !h-28px !leading-28px !p-0'>
              {event.reason == REASON_MAP.RISK_CONTROL ? '我已知晓' : '再次尝试'}
            </Button>
          </div>
        </div>
      )
    }
    return null;
  }

  // 并行 mcp，一个会话中会出多个 "type":"agentStatus"，产生空行
  if(event.type == "agentStatus" && mcpStore.isAgentFlow){
    return null;
  }

  return (
    <div className='mcp-summary mt-0px'>
      {/* 编辑任务规划 */}
      {plan !== undefined ? (
        <McpToolsPlan
          planList={planList}
          planed={event.plan_state == 1}
          planStepId={event.planStepId}
          requestPlanParams={{
            cid: event.conversation_id,
            msg_id: event.msg_id,
            plan_id: event.planStepId,
          }}
          onRenew={onRenew}
          onSave={res => {
            //console.log(res);
          }}
          onDelete={res => {
            //console.log(res);
          }}
          onExecute={res => {
            chatStoreManager.current?.sendMessage({
              input: '开始执行',
              plan_id: event.planStepId,
              plan_message_id: event.msg_id,
            });
          }}
        />
      ) : null}

      {
        fixedAttachments.textAttachments.map((item, index) => {
          return (
            <div className="mcp-summary-texts" key={`text_${index}`}>
              <Markdown text={item.content} />
            </div>
          )
        })
      }

      {
        fixedAttachments.htmlAttachments.map((item, index) => {
          return (
            <McpSummaryLink 
              key={`html_${index}`}
              mcpStore={mcpStore} 
              attachment={item} 
              event={event} 
              messageItem={messageItem}
              >
            </McpSummaryLink>
          )
        })
      }

      {
        content
        ? <Markdown text={content} />
        : null
      }

      {
        fixedAttachments.videoAttachments.map((item, index) => {
          return (
            <McpToolsVideo 
              key={`video_${index}`}
              mcpStore={mcpStore} 
              event={item} 
              messageItem={messageItem}
              >
            </McpToolsVideo>
          )
        })
      }

      <div className="">
        <McpToolsFiles mcpStore={mcpStore} attachments={fixedAttachments.fileAttachments} messageItem={messageItem} />
      </div>
      {
        !messageItem.isMcpShare ? <McpSummaryOutput {...props} /> : null
      }
    </div>
  )
});
export default McpSummary;